module.exports = __webpack_public_path__ + "static/media/LV-CCL.dbb579cc.jpg";